var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewfolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.257,
    height: 76.162,
    viewBox: "0 0 85.257 76.162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3729",
    "data-name": "Group 3729",
    transform: "translate(-73 -30.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3639",
    "data-name": "Group 3639",
    transform: "translate(73 30.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1514",
    "data-name": "Rectangle 1514",
    width: 85.257,
    height: 76.162,
    rx: 4,
    fill: "#009bad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    d: "M158.223,125.242H117.749a1.665,1.665,0,0,0-.83.216,1.382,1.382,0,0,0-.558.58L109.9,139.072h43.765l5.946-11.981a1.181,1.181,0,0,0-.123-1.253,1.578,1.578,0,0,0-1.266-.6Zm-12.7,12.809H136.54a.515.515,0,1,1,0-1.022h8.978a.516.516,0,1,1,0,1.022Zm7,0h-3.684a.515.515,0,1,1,0-1.022h3.684a.516.516,0,1,1,0,1.022ZM117.752,124.22h35.714v-9.8a1.25,1.25,0,0,0-.444-.938,1.636,1.636,0,0,0-1.072-.39H135.335a5.891,5.891,0,0,1-4.069-1.572l-3.042-2.924h0a3.61,3.61,0,0,0-2.505-.971H111.109a1.636,1.636,0,0,0-1.072.39,1.249,1.249,0,0,0-.443.939v28.173l5.7-11.49a2.451,2.451,0,0,1,.989-1.028,2.958,2.958,0,0,1,1.472-.383Zm-5.822-2.136a.589.589,0,0,1-1.168,0v-7.926a.589.589,0,0,1,1.168,0Zm0-10.747h0a.589.589,0,0,1-1.168,0v-2.181a.589.589,0,0,1,1.168,0Z",
    transform: "translate(-92.164 -84.488)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewfolder);
export default __webpack_public_path__ + "static/media/newfolder.9aed508dd3f87861e64a239e6f79d779.svg";
export { ForwardRef as ReactComponent };